import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=795f9302&scoped=true&"
import script from "./PageDetail.vue?vue&type=script&lang=js&"
export * from "./PageDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageDetail.vue?vue&type=style&index=0&id=795f9302&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f9302",
  null
  
)

export default component.exports